import { render, staticRenderFns } from "./ExpandableView.vue?vue&type=template&id=2fd5ec4e&"
import script from "./ExpandableView.vue?vue&type=script&lang=js&"
export * from "./ExpandableView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports